import { useTranslation } from "react-i18next";
import { Divider, Form } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import "modules/DealerOverviewDashboard/components/DmsSystem/components/SystemInfo/SystemInfo.scss";

import type { DealerOverviewFormPayload } from "modules/DealerOverviewDashboard/hooks";

const FormHelper = createFormHelper<DealerOverviewFormPayload>();

export const SystemInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Group className="SystemInfo">
        <Form.Field width={8}>
          <div className="dealer-overview-subheading">{t("v8_system_info", "System Info")}</div>
          <Form.Field className="sys-info-field">
            <label>{t("v8_dms_server_information", "DMS server information")}</label>
            <FormHelper.Field.Input name="dms_server_info" />
          </Form.Field>

          <Form.Field className="sys-info-field">
            <label>{t("v8_general_system_information", "General system information")}</label>
            <FormHelper.Field.TextArea name="network_info" textAreaProps={{ rows: 4 }} />
          </Form.Field>
        </Form.Field>

        <Form.Field width={8}>
          <div className="dealer-overview-subheading">{t("v8_admin_contact", "Admin Contact")}</div>
          <Form.Field className="sys-info-field">
            <label>{t("v8_system_admin_phone", "System admin phone")}</label>
            <FormHelper.Field.Input name="sys_admin_phone" />
          </Form.Field>

          <Form.Field className="sys-info-field">
            <label>{t("v8_system_admin_name", "System admin name")}</label>
            <FormHelper.Field.Input name="sys_admin_name" />
          </Form.Field>

          <Form.Field className="sys-info-field">
            <label>{t("v8_system_admin_email", "System admin email")}</label>
            <FormHelper.Field.Input name="sys_admin_email" />
          </Form.Field>
        </Form.Field>
      </Form.Group>
      <Divider />
    </>
  );
};
